import { runInAction } from "mobx";
import ProcessoApi from "../api/ProcessoApi";
import ProcessoStore from "../store/ProcessoStore";

class ImpedimentoService {
    buscarImpedimentosDeTodosOsProcessos = async () => {
        if (ProcessoStore.carregouImpedimentos) {
            return;
        }
        runInAction(() => {
            ProcessoStore.carregandoImpedimentosDeProcesso = true;
        });
        try {
            const ids = ProcessoStore._processos.map(proc => proc.identificadorProcesso);
            const impedimentos = await ProcessoApi.buscarImpedimentos(ids);

            runInAction(() => {
                for (let cnt = 0; cnt < ProcessoStore._processos.length; cnt++) {
                    const processo = ProcessoStore._processos[cnt];
                    if (impedimentos[processo.identificadorProcesso] != undefined && impedimentos[processo.identificadorProcesso].length > 0)
                        processo.impedimentos = impedimentos[processo.identificadorProcesso];
                }
                ProcessoStore.carregouImpedimentos = true;
            });
        } catch (erro) {
            console.error('Erro ao buscar impedimentos dos processos:', erro);
        } finally {
            runInAction(() => {
                ProcessoStore.carregandoImpedimentosDeProcesso = false;
            });
        }
    }
}

export default new ImpedimentoService();